const reportTmk = [{
  desc: '保单情况',
  options: {
    url: '/reportTmk/queryInsuranceSumForJSC',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '业务员出单保费排名Top10/业务员出单量排名Top10',
  options: {
    url: '/reportTmk/getTmkOutInsPersonnelTop',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '团队个人实时出单监控',
  options: {
    url: '/reportTmk/getTmkOutInsStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '分支机构保费排名后10/分支机构保费排名前10',
  options: {
    url: '/reportTmk/getInsBranchOrgStatisticsForJSC',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}]
export default reportTmk



// WEBPACK FOOTER //
// ./src/api/reportTmk.js